module.exports = __webpack_public_path__ + "static/media/logitravel.5abb755e.jfif";